import { RouterInputs, ReactQueryOptions, api } from "@api";
type inputType = RouterInputs['ToyManager']['getTotalAmount'];
type queryOptionsType = ReactQueryOptions['ToyManager']['getTotalAmount'];
export const useGetTotalToysAmount = (input: inputType, options?: queryOptionsType) => {
  return api.ToyManager.getTotalAmount.useQuery(input, {
    ...options,
    queryKey: ['ToyManager.getTotalAmount', input],
    staleTime: 1000 * 60 * 60 * 8
  });
};